import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import Form from "../../../components/form/Form";
import {
  fetchSingleOffice,
  resetStatus,
  updateOffice,
} from "../../../redux/slice/office/officeSlice";
import {
  getObjectKeys,
  isEmptyObject,
} from "../../../utils/validators/validators";
import PageTitle from "./../../../components/partials/PageTitle";
import useInputChange from "./../../../utils/hooks/useInputChange";

const OfficeDetails = () => {
  const [canEditOffice, setCanEditOffice] = useState();
  const [editing, setEditing] = useState(false);
  const [error, setError] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user_permissions } = useSelector((state) => state.auth?.user);
  const { offices, isLoading, single_office, isSuccess } = useSelector(
    (state) => state.office
  );
  const {
    office_address,
    location,
    id: officeId,
    office_name,
    parent_id,
    office_code,
  } = single_office;
  const [officeInputData, setOfficeInputData] = useState({
    location,
    office_address,
    officeId,
    office_name,
    parent_id,
    office_code,
  });
  const [input, handleChange] = useInputChange(
    officeInputData,
    setOfficeInputData,
    error,
    setError
  );

  // get office id from url
  const { id } = useParams();

  // Fetch office datails
  const fetchDetailsHandler = (id) => {
    dispatch(fetchSingleOffice(id));
  };

  // Input change handler
  // const inputChangeHandler = (e) => {
  //     e.preventDefault()
  //     let {name, value} = e.target

  //     // remove item from state object using key
  //     if(getObjectKeys(error).length !== 0){
  //         setError(current => {
  //             const copy = {...current}
  //             delete copy[name]
  //             return copy
  //         })
  //     }

  //     setOfficeInputData(() => {
  //         return {...officeInputData, [name] : value}
  //     })
  // }

  // update office details
  const handleSubmit = () => {
    if (isEmptyObject(error)) {
      dispatch(updateOffice(officeInputData));
      navigate("/admin/office-list", { replace: true });
      setEditing(!editing);
    }
  };

  const handleClose = () => {
    setOfficeInputData({
      office_address: single_office.office_address,
      office_name: single_office.office_name,
      location: single_office.location,
      officeId: single_office.id,
      parent_id: single_office.parent_id,
      office_code: single_office.office_code,
    });
  };

  // Initialize Input Fields
  const initializeInputField = () => {
    if (!isLoading) {
      setOfficeInputData({
        office_address: single_office.office_address,
        office_name: single_office.office_name,
        location: single_office.location,
        officeId: single_office.id,
        parent_id: single_office.parent_id,
        office_code: single_office.office_code,
      });
    }
  };

  useEffect(() => {
    fetchDetailsHandler(id);
  }, []);

  useEffect(() => {
    if (isSuccess) {
      dispatch(resetStatus());
    }
  }, [isSuccess]);

  useEffect(() => {
    initializeInputField();
  }, [single_office]);

  const breadcrumb = {
    from: {
      title: "Office",
      link: "/admin/office-list",
    },
    current: {
      title: "office details",
      link: null,
    },
  };

  useEffect(() => {
    if (
      !user_permissions?.some(
        (permission) => permission.name === "office module"
      ) ||
      !user_permissions?.some((permission) => permission.name === "view office")
    ) {
      navigate("/admin/dashboard");
    }

    setCanEditOffice(
      user_permissions?.some((permission) => permission.name === "edit office")
    );
  }, [navigate, user_permissions]);

  return (
    <>
      {/* page title */}
      <PageTitle title='Office Details' breadcrumb={breadcrumb} />
      {/* end page title */}

      {isLoading ? (
        <div className='table-loader'>
          <BeatLoader color='#e0d5d5' margin={5} size={7} />
        </div>
      ) : (
        <div className='card'>
          <div className='card-body'>
            <div className='row border-bottom pb-2 mb-3'>
              <div className='col-md-12 d-flex justify-content-between align-items-center'>
                <h4 className='header-title fs-5 fw-bold text-capitalize '>
                  Office Information
                </h4>
                <span
                  onClick={() => navigate(-1)}
                  className='btn btn-primary float-nd'
                >
                  Go back
                </span>
              </div>
            </div>
            <Form
              method='POST'
              setError={setError}
              submitHandler={handleSubmit}
              values={officeInputData}
            >
              <div className='row g-2 mb-3'>
                <div className={`"mb-0 ${editing ? "col-md-6" : "col-md-12"}`}>
                  <label htmlFor='inputEmail4' className='form-label'>
                    Office Name{" "}
                    {editing && <span className='text-danger'>*</span>}
                  </label>
                  <input
                    type='name'
                    textname='office name'
                    name='office_name'
                    value={input?.office_name}
                    onChange={handleChange}
                    className={`form-control ${
                      error.office_name && "is-invalid"
                    }`}
                    id='inputEmail4'
                    placeholder='Office Name'
                    disabled={editing ? false : true}
                  />
                  {error.office_name && (
                    <span className='invalid-feedback'>
                      {error.office_name}
                    </span>
                  )}
                </div>
                {editing && (
                  <div className='col-md-6'>
                    <label htmlFor='inputState' className='form-label'>
                      Change Parent Office{" "}
                      {editing && <span className='text-danger'>*</span>}
                    </label>
                    <select
                      textname='parent office'
                      name='parent_id'
                      value={input?.parent_id || ""}
                      onChange={handleChange}
                      id='inputState'
                      className={`form-select ${
                        error.parent_id && "is-invalid"
                      }`}
                      disabled={
                        editing && officeInputData?.officeId !== 1
                          ? false
                          : true
                      }
                    >
                      <option value=''>Choose</option>
                      {offices.offices
                        .filter((f) => f.id !== single_office.id)
                        .map((office, index) => (
                          <option
                            key={index}
                            value={office.id ? office.id : ""}
                          >
                            {office.office_name}
                          </option>
                        ))}
                    </select>
                    {error.parent_id && (
                      <span className='invalid-feedback'>
                        {error.parent_id}
                      </span>
                    )}
                  </div>
                )}
              </div>
              {!editing && (
                <div className='row mb-3'>
                  <div className='mb-0 col-md-12'>
                    <label htmlFor='inputEmail4' className='form-label'>
                      Parent Office
                    </label>
                    <input
                      type='name'
                      value={
                        single_office?.parent?.office_name || "Head Office"
                      }
                      className='form-control'
                      id='inputEmail4'
                      placeholder='Office Name'
                      disabled={true}
                    />
                  </div>
                </div>
              )}

              <div className='mb-3 row'>
                <div className='col-md-6'>
                  <label htmlFor='location' className='form-label'>
                    Location {editing && <span className='text-danger'>*</span>}
                  </label>
                  <input
                    type='text'
                    textname='location'
                    name='location'
                    value={input?.location}
                    onChange={handleChange}
                    className={`form-control ${error.location && "is-invalid"}`}
                    id='inputAddress'
                    placeholder='Benin City'
                    disabled={editing ? false : true}
                  />
                  {error.location && (
                    <span className='invalid-feedback'>{error.location}</span>
                  )}
                </div>
                <div className='col-md-6'>
                  <label htmlFor='location' className='form-label'>
                    Office Short Code{" "}
                    {editing && <span className='text-danger'>*</span>}
                  </label>
                  <input
                    type='text'
                    // textname='location'
                    name='office_code'
                    value={input?.office_code}
                    onChange={handleChange}
                    className={`form-control ${
                      error.office_code && "is-invalid"
                    }`}
                    id='office_code'
                    // placeholder="Benin City"
                    disabled={editing ? false : true}
                  />
                  {error.office_code && (
                    <span className='invalid-feedback'>
                      {error.office_code}
                    </span>
                  )}
                </div>
              </div>
              <div className='mb-3'>
                <label htmlFor='example-textarea' className='form-label'>
                  Address {editing && <span className='text-danger'>*</span>}
                </label>
                <textarea
                  className={`form-control ${
                    error.office_address && "is-invalid"
                  }`}
                  id='example-textarea'
                  rows='5'
                  disabled={editing ? false : true}
                  name='office_address'
                  textname='address'
                  value={input?.office_address}
                  onChange={handleChange}
                ></textarea>
                {error.office_address && (
                  <span className='invalid-feedback'>
                    {error.office_address}
                  </span>
                )}
              </div>

              {canEditOffice && (
                <div className=' float-end'>
                  <button
                    className='btn btn-primary px-4'
                    onClick={() => {
                      setEditing(!editing);
                      handleClose();
                    }}
                    type='button'
                  >
                    {editing ? "Close" : "Edit"}
                  </button>
                  {editing && (
                    <button className='btn btn-success px-4 mx-2'>Save</button>
                  )}
                </div>
              )}
            </Form>
          </div>
        </div>
      )}
    </>
  );
};

export default OfficeDetails;
